import { ZVUK_API_GRAPHQL_URL } from '@shared/config/env';
import { GraphQLFormattedError } from 'graphql';

const JWT_ERRORS_MESSAGES = ['Signature has expired', 'Error decoding signature'];
const AUTH_ERRORS_MESSAGES = [
  'You do not have permission to perform this action',
  'Invalid token',
  'Refresh token is required',
];
const TOKEN_REFRESH_TIMEOUT_MS = 10_000;

class DataProviderUtils {
  static async tokenRefresh(): Promise<string | undefined> {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), TOKEN_REFRESH_TIMEOUT_MS);

    try {
      const result = await fetch(ZVUK_API_GRAPHQL_URL, {
        headers: { 'content-type': 'application/json' },

        body: '{"query":"mutation tokenPureRefresh($input: TokenPureRefreshMutationInput!) {\\n  tokenPureRefresh(input: $input) {\\n    token\\n    refreshExpiresIn\\n    payload\\n  }\\n}","variables":{"input":{"refreshToken":""}},"operationName":"tokenPureRefresh"}',
        method: 'POST',
        mode: 'cors',
        signal: controller.signal,
      });

      const response = await result.json();
      return response?.data?.tokenPureRefresh?.token;
    } catch (_e) {
      return undefined;
    } finally {
      clearTimeout(timeoutId);
    }
  }

  static checkIsJWTExpiredError(errors: readonly GraphQLFormattedError[]): boolean {
    return !!errors.find(({ message }) => JWT_ERRORS_MESSAGES.includes(message));
  }

  static checkIsAuthError(errors: readonly GraphQLFormattedError[]): boolean {
    return !!errors.find(({ message }) => AUTH_ERRORS_MESSAGES.includes(message));
  }
}

export default DataProviderUtils;
